<template>
<c-view>
  <c-page>
    <div class="main">
    </div>
  </c-page>
  <router-view></router-view>
</c-view>
</template>

<script>
import RenewalModel from '../../model/renewal'
import Pay from '../../model/pay'
export default {
  name: 'Renewal',
  data () {
    return {}
  },
  async mounted () {
    let payType = this.$route.params.payType
    // 获取支付的版本信息
    let json = await RenewalModel.getCurrentVersionInfo()
    let busId = json.data.busId
    if (!payType) {
      this.$wejs.alert('未获取到支付方式')
      return
    }
    if (!busId) {
      this.$wejs.alert('未获取到商品信息')
      return
    }
    new Pay().renewalSass(busId, parseInt(payType))
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// index.vue?38f261c4